import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'submit'];

  connect () {
    this.toggleSubmit = this.toggleSubmit.bind(this);

    this.toggleSubmit();
    this.inputTargets.forEach((input) => {
      input.addEventListener('input', this.toggleSubmit);
      input.addEventListener('change', this.toggleSubmit);
    });
  }

  disconnect () {
    this.inputTargets.forEach((input) => {
      input.removeEventListener('input', this.toggleSubmit);
      input.removeEventListener('change', this.toggleSubmit);
    });
  }

  toggleSubmit () {
    const isDisabled = this.inputTargets.some((input) => !this.isInputSatisfied(input));
    this.submitTarget.disabled = isDisabled;
    this.toggleClasses(isDisabled);
  }

  isInputSatisfied (input) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      return input.checked;
    }
    const value = (input.value ?? '').trim();
    return !!value.length;
  }

  toggleClasses (isDisabled) {
    if (isDisabled) return this.submitTarget.classList.add('btn-disabled');
    return this.submitTarget.classList.remove('btn-disabled');
  }
}